import React from 'react';
import {Box, Theme, useMediaQuery} from '@mui/material';
import ZooskLogo from 'components/ZooskLogo';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles, useTheme } from '@mui/styles';
import WithlocalsLogoSmall from 'components/WithlocalsLogoSmall';
import PrivacyTnC from 'components/PrivacyTnC';

const useStyles = makeStyles((theme: any) =>
  createStyles({
    logo: {
      placeSelf: 'center',
      maxHeight: '1.5rem',
      [theme.breakpoints.up('md')]: {
        maxHeight: '2.5rem'
      }
    }
  })
);

type DefaultLayoutProps = {
  children: any;
  hideFooter?: boolean;
  hideBackButton?: boolean;
  onBack?: () => void;
}

const DefaultLayout = ({children, onBack, hideFooter, hideBackButton}: DefaultLayoutProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const onBackClick = () => {
    if (hideBackButton)
      return;

    if (onBack) {
      onBack();
      return;
    }

    history.goBack();
    return;
  };

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateRows: '4rem 1fr',
      [theme.breakpoints.up('md')]: {
        maxWidth: '1300px',
        margin: '0 auto'
      }
    }}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: '4rem 1fr',
        borderBottom: '1px solid #F2F3F5',
        [theme.breakpoints.up('md')]: {
          borderBottom: 'none',
          width: '100%',
          gridTemplateColumns: '4rem 1fr 4rem',
        }
      }}>
        {!hideBackButton ?
          <IconButton onClick={onBackClick} size={'small'}>
				  <ArrowBackIosNewIcon htmlColor={'#023669'}/>
          </IconButton> :
          <div/>
        }
        <Box display={'flex'} sx={{ placeItems: 'center', justifyContent: 'space-evenly' }}>
          <ZooskLogo width={isMobile ? 192 : 310} className={classes.logo}/>
          <Box marginLeft={'auto'}>
            <WithlocalsLogoSmall className={classes.logo} color={'var(--razzmatazz)'} width={84}/>
          </Box>
        </Box>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
      >{children}</Box>
      {!isMobile &&
			<Box padding={'.5rem'} marginTop={'auto'}>
			  <PrivacyTnC/>
			</Box>
      }
    </Box>
  )
};

export default DefaultLayout;